module.exports = __webpack_public_path__ + "static/celebration-3438ed2e53a7864e205dcf29ba9d28a1.jpg";